// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fslightbox-slide-btn-container {\n  top: calc(50% - 60px);\n}\n", "",{"version":3,"sources":["webpack://./src/app/common/components/Lightbox/Lightbox.less"],"names":[],"mappings":"AACA;EACE,qBAAA;AAAF","sourcesContent":["// override arrow/slider positions so they are not covered by Elevio's \"Help\" button\n:global(.fslightbox-slide-btn-container) {\n  top: calc(50% - 60px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
